import { Component, ViewChild } from '@angular/core';
import { DigitalTemplatesViewModel } from './digital-templates-view-model';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../../../models/base/base-component';
import { TabBarComponent } from '../../../../shared/components/tab-bar/tab-bar.component';

@Component({
  selector: 'app-digital-templates',
  templateUrl: './digital-templates.component.html',
  styleUrls: ['./digital-templates.component.scss'],
  providers: [DigitalTemplatesViewModel],
  standalone: false
})
export class DigitalTemplatesComponent extends BaseComponent {
  constructor(
    public viewModel: DigitalTemplatesViewModel,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  @ViewChild('tabController') tabController: TabBarComponent;

  override setupBindings(): void {
    // Capture the fragment if available and navigates to a specific tab
    const fragSub = this.activatedRoute.fragment.notNull().subscribe(fragment => {
      switch (fragment?.toLowerCase()) {
        case 'producttemplates':
          this.tabController.tabSelected(0);
          break;
        case 'spotlighttemplates':
          this.tabController.tabSelected(1);
          break;
        case 'marketingtemplates':
          this.tabController.tabSelected(2);
          break;
        case 'templatecollections':
          this.tabController.tabSelected(3);
          break;
      }
    });
    this.pushSub(fragSub);
  }
}
